// extracted by mini-css-extract-plugin
module.exports = {"main":"profile-orders-page_main__2wHq8","container":"profile-orders-page_container__3P3oT","menu":"profile-orders-page_menu__3Y8CV","orders":"profile-orders-page_orders__38dSm"};